import { legalEnA } from "./legalEnA";
import { legalEnB } from "./legalEnB";
import { legalEsA } from "./legalEsA";
import { legalEsB } from "./legalEsB";

export const LEGAL_SLUGS = ["terms", "privacy", "cookies", "refunds", "content", "dmca", "age-safety", "creator-terms", "acceptable-use", "complaints"];

export const legalDocs = {
  en: [...legalEnA, ...legalEnB],
  es: [...legalEsA, ...legalEsB],
};

export const getLegalDoc = (lang, slug) => legalDocs[lang].find((d) => d.slug === slug);
